import { InputSelect, InputText, MenuItemType } from '@innovyze/stylovyze';
import { Typography } from '@mui/material';
import { FormikErrors, useFormikContext } from 'formik';
import React from 'react';

import { useGlobalization } from '@Translations/useGlobalization';
import { ValuemappingProfileFormShape } from '@Types/valuemappingForm.types';
import {
	CenteredWrapper,
	ValueMappingMissingValueRowContent,
} from './ValueMappingMissingValueRow.styles';

export interface ValueMappingMissingValueRowProps {
	index: number;
	mappingMethodOptionItems: MenuItemType[];
	errors: FormikErrors<ValuemappingProfileFormShape>;
}

export const ValueMappingMissingValueRow = ({
	index,
	mappingMethodOptionItems,
	errors,
}: ValueMappingMissingValueRowProps) => {
	const { values } = useFormikContext<ValuemappingProfileFormShape>();
	const { t } = useGlobalization();

	return (
		<>
			<CenteredWrapper>
				<Typography>{t('When the value is missing:')}</Typography>
			</CenteredWrapper>
			<ValueMappingMissingValueRowContent>
				<InputSelect
					dataCy="valuemappingMethodField"
					key={`valuemappingMethodField-${index}`}
					menuItems={mappingMethodOptionItems}
					fieldAttrs={{
						required: true,
						name: `mappings[${index}].method`,
						defaultValue: mappingMethodOptionItems[0].value,
						// value: mappingMethodOptionItems[0].value,
					}}
					helperText={
						(errors as Record<string, string>)[
							`${t('mappings')}[${index}].${t('method')}`
						]
					}
					selectProps={{
						label: t('Replace with'),
						variant: 'outlined',
						color: 'primary',
						defaultValue: mappingMethodOptionItems[0].value,
						// value: mappingMethodOptionItems[0].value,
						error: !!(errors as Record<string, string>)[
							`${t('mappings')}[${index}].${t('method')}`
						],
					}}
				/>
				{values.mappings[index]?.method !== 'Last Known Value' && (
					<InputText
						dataCy="valuemappingtoField"
						key={`valuemappingtoField-${index}`}
						fieldAttrs={{
							required: true,
							name: `${t('mappings')}[${index}].${t('to')}`,
						}}
						textField={{
							InputLabelProps: { shrink: true },
							label: t('Replacement value'),
							variant: 'outlined',
							color: 'primary',
							helperText: (errors as Record<string, string>)[
								`${t('mappings')}[${index}].${t('to')}`
							],
							error: !!(errors as Record<string, string>)[
								`${t('mappings')}[${index}].${t('to')}`
							],
							autoComplete: 'off',
						}}
					/>
				)}
			</ValueMappingMissingValueRowContent>
		</>
	);
};

export default ValueMappingMissingValueRow;
